export default __webpack_public_path__ + "Kuantum5.pdf";